<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 2H7C7.55228 2 8 2.44772 8 3C8 3.51284 7.61396 3.93551 7.11662 3.99327L7 4H5C4.48716 4 4.06449 4.38604 4.00673 4.88338L4 5V19C4 19.5128 4.38604 19.9355 4.88338 19.9933L5 20H19C19.5128 20 19.9355 19.614 19.9933 19.1166L20 19V17C20 16.4477 20.4477 16 21 16C21.5128 16 21.9355 16.386 21.9933 16.8834L22 17V19C22 20.5977 20.7511 21.9037 19.1763 21.9949L19 22H5C3.40232 22 2.09634 20.7511 2.00509 19.1763L2 19V5C2 3.40232 3.24892 2.09634 4.82373 2.00509L5 2H7H5ZM21 2L21.081 2.003L21.2007 2.02024L21.3121 2.04974L21.4232 2.09367L21.5207 2.146L21.6167 2.21279L21.7071 2.29289L21.8037 2.40469L21.8753 2.51594L21.9063 2.5769L21.9401 2.65835L21.9642 2.73401L21.9931 2.8819L22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V5.414L13.7071 11.7071C13.3466 12.0676 12.7794 12.0953 12.3871 11.7903L12.2929 11.7071C11.9324 11.3466 11.9047 10.7794 12.2097 10.3871L12.2929 10.2929L18.584 4H15C14.4477 4 14 3.55228 14 3C14 2.44772 14.4477 2 15 2H21Z"
    fill="currentColor"
  />
</svg>
